module.exports = __webpack_public_path__ + "img/wallet.b00b789a.png";